/* global _ */

Wee.fn.make('products', {
	init: function() {
		var priv = this.$private;

		priv.setVars();
		priv.initEvents();
		priv.initScreen();
		priv.toggleFilters();
		priv.initSticky();
		priv.clearFilters();
	},

	unload: function() {
		$.events.off(false, '.products');
	}
}, {
	/**
	 * Set variables for use in controller
	 *
	 * @private
	 */
	setVars: function() {
		this.$content = $('ref:productsContent');
		this.$win = $($._win);
		this.$filters = $('ref:filters');
		this.$filterToggle = $('ref:filterToggle');
		this.$filterTrigger = $('ref:filterTrigger');
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		Wee.events.on({
			'window': {
				scroll: _.throttle(scope.initSticky.bind(scope), 40, {
					'trailing': true
				}),
				resize: _.throttle(scope.initSticky.bind(scope), 40, {
					'trailing': true
				})
			},
			'ref:filterCheckbox': {
				change: function(e, el) {
					var data = $(el).closest('ref:filterForm').serialize(true),
						normalized = scope.normalizeFilters(data),
						$body = $('ref:body');

					scope.updateFilters(normalized);

					if ($body.isDisabled()) {
						$body.enable();
					}
				}
			}
		}, {
			namespace: 'products'
		});
	},

	/**
	 *	Get array of values from key in JSON object
	 *
	 * @private
	 */
	normalizeFilters: function(data) {
		for (var filterList in data) {
			if (data.hasOwnProperty(filterList) && Wee.$isArray(data[filterList])) {
				data[filterList] = data[filterList].join('|');
			}
		}

		return decodeURI(Wee.$serialize(data));
	},

	/**
	 * Add filters and values to query string
	 *
	 * @private
	 */
	updateFilters: function(data) {
		$.history.go({
			path: Wee.routes.uri().path + '?' + data,
			scrollTop: $('ref:productsContent').offset().top
		});
	},

	/**
	 * Init screen
	 *
	 * @private
	 */
	initScreen: function() {
		var scope = this,
			isFixed = '-is-fixed';

		Wee.screen.map([
			{
				max: 3,
				callback: function() {
					scope.$filters.disable();
					scope.$filterToggle.show();

					if (scope.$filterTrigger.hasClass(isFixed)) {
						scope.$filterTrigger.removeClass(isFixed);
					}
				}
			},
			{
				min: 4,
				callback: function() {
					scope.$filterToggle.removeClass(isFixed).hide();

					if (scope.$filters.isDisabled()) {
						scope.$filters.enable();
					}
				}
			}
		]);
	},

	/**
	 * Show filters panel on mobile/tablet
	 *
	 * @private
	 */
	toggleFilters: function() {
		var scope = this,
			$body = $('ref:body');

		scope.$filterToggle.on('click', function() {
			scope.$filters.isDisabled() ? scope.$filters.enable() : scope.$filters.disable();
			$body.isDisabled() ? $body.enable() : $body.disable();

			if (scope.$filterTrigger.hasClass('-is-fixed')) {
				$('ref:filtersContainer').offset({
					top: 0,
					left: 0
				});
			}
		});
	},

	/**
	 * Sticky filters/product content when at top of screen
	 *
	 * @private
	 */
	initSticky: function() {
		var scrollPosition = this.$win.scrollTop();

		if (scrollPosition >= this.$content.offset().top) {
			this.$filterTrigger.addClass('-is-fixed');
		} else {
			this.$filterTrigger.removeClass('-is-fixed');
		}
	},

	/**
	 * Clear filters
	 *
	 * @private
	 */
	clearFilters: function() {
		var $body = $('ref:body');

		$('ref:filterClear').on('click', function() {
			$('ref:filterCheckbox').filter(':checked').each(function() {
				$(this).prop('checked', false);
			});

			if ($body.isDisabled()) {
				$body.enable();
			}

			$.history.go({
				path: '/products/' + Wee.routes.segments(1),
				scrollTop: $('ref:productsContent').offset().top
			});
		});
	}

});